export interface IPhoto {
  id: number;
  path: string;
}

export const PHOTOS: IPhoto[] = [{
      id: 1,
      path: 'Photo1.webp'
  }, {
      id: 2,
      path: 'Photo2.webp'
  }, {
      id: 3,
      path: 'Photo3.webp'
  }, {
      id: 4,
      path: 'Photo4.webp'
  }, {
      id: 5,
      path: 'Photo5.webp'
  }, {
      id: 6,
      path: 'Photo6.webp'
  }
];
